









import { Component, Prop, Vue } from 'vue-property-decorator';
import { numberOrNull, Items, ComponentProps } from './types';

@Component
export default class ComponentsPartsSliderBadges
  extends Vue
  implements ComponentProps {
  // props
  @Prop({ type: Array, default: () => [] })
  items: Items;

  @Prop({ type: Number, default: 5000 })
  interval: number;

  // data
  curr: number = 0;
  timer: numberOrNull = null;

  // Hooks
  mounted() {
    if (this.items && this.items.length > 1) {
      this.timer = window.setInterval(() => {
        let next = this.curr + 1;
        this.curr = next < this.items.length ? next : 0;
      }, this.interval);
    }
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/badges/Badges.vue